import { FilterAction } from '@/types/SearchFacet';

const FILTER_ACTION_TO_FIELD: Record<string, string> = {
    [FilterAction.AuctionHouseChanged]: 'house',
    [FilterAction.AuctionHouseRemoved]: 'house',
    [FilterAction.BuyingFormatChanged]: 'buyingFormat',
    [FilterAction.BuyingFormatRemoved]: 'buyingFormat',
    [FilterAction.CategoryChanged]: 'category',
    [FilterAction.CategoryRemoved]: 'category',
    [FilterAction.ClearAllFilters]: 'clearAll',
    [FilterAction.CreatorChanged]: 'creator',
    [FilterAction.CreatorRemoved]: 'creator',
    [FilterAction.CurrentBidChanged]: 'currentBid',
    [FilterAction.CurrentBidRemoved]: 'currentBid',
    [FilterAction.FilterTermAdded]: 'filterTerm',
    [FilterAction.FilterTermRemoved]: 'filterTerm',
    [FilterAction.HammerPriceChanged]: 'hammerPrice',
    [FilterAction.HammerPriceRemoved]: 'hammerPrice',
    [FilterAction.HouseExcluded]: 'house',
    [FilterAction.LocationChanged]: 'location',
    [FilterAction.LocationRemoved]: 'location',
    [FilterAction.MaterialsAndTechniquesChanged]: 'material',
    [FilterAction.MaterialsAndTechniquesRemoved]: 'material',
    [FilterAction.OriginChanged]: 'origin',
    [FilterAction.OriginRemoved]: 'origin',
    [FilterAction.PageChanged]: 'page',
    [FilterAction.PageSizeChanged]: 'pageSize',
    [FilterAction.PriceRangeChanged]: 'price',
    [FilterAction.PriceRangeRemoved]: 'price',
    [FilterAction.PublishDateChanged]: 'publishDate',
    [FilterAction.PublishDateRemoved]: 'publishDate',
    [FilterAction.PublishedDateRemoved]: 'publishDate',
    [FilterAction.RatingChanged]: 'rating',
    [FilterAction.RatingRemoved]: 'rating',
    [FilterAction.SaleDateChanged]: 'saleDate',
    [FilterAction.SaleDateRemoved]: 'saleDate',
    [FilterAction.ShippingChanged]: 'shipping',
    [FilterAction.ShippingRemoved]: 'shipping',
    [FilterAction.SortByChanged]: 'sort',
    [FilterAction.StylePeriodChanged]: 'stylePeriod',
    [FilterAction.StylePeriodRemoved]: 'stylePeriod',
    [FilterAction.ViewPriceResults]: 'status',
    [FilterAction.ViewUpcomingItems]: 'status',
};

export const getFilteredFieldFromFilterAction = (filterAction: FilterAction | string): string | undefined =>
    FILTER_ACTION_TO_FIELD[filterAction];
